var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkbox"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 66 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2071 4.79289C13.5976 5.18342 13.5976 5.81658 13.2071 6.20711L7.70711 11.7071C7.31658 12.0976 6.68342 12.0976 6.29289 11.7071L2.79289 8.20711C2.40237 7.81658 2.40237 7.18342 2.79289 6.79289C3.18342 6.40237 3.81658 6.40237 4.20711 6.79289L7 9.58579L11.7929 4.79289C12.1834 4.40237 12.8166 4.40237 13.2071 4.79289Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckbox);
export default __webpack_public_path__ + "static/media/iconCheckbox.424ad7669264f51d3be5e3fc8bbfbfd6.svg";
export { ForwardRef as ReactComponent };